import { render, staticRenderFns } from "./UploadVideoFileMenu.vue?vue&type=template&id=31be8cc8&"
import script from "./UploadVideoFileMenu.vue?vue&type=script&lang=ts&"
export * from "./UploadVideoFileMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports